module.exports = __webpack_public_path__ + "img/certificate-ja.d920230e.png";